import { useTranslation } from "react-i18next";
import { styled, Typography } from "~/common/mui";
import { PriceElements, type PriceProps } from "~/domains/pricing/components/Price/PriceV4";
import * as PriceUtils from "~/utils/PriceUtils";

export const TariffSurchargeAsterisk = () => {
  const { t } = useTranslation();
  return <Typography color="textLabel">{t("price.tariff.surcharge.applicable")}</Typography>;
};

export const IncludedSurchargeAsterisk = ({ value, percent }: { value?: PriceData; percent?: number }) => {
  const { t } = useTranslation();

  if (!value) {
    return null;
  }

  const label = t("cart.param.includedSurcharge");
  let text;
  if (percent && percent > 0) {
    text = `${PriceUtils.text2(value, "-")} (${percent * 100}%)`;
  } else {
    text = PriceUtils.text2(value, "-");
  }
  return <Typography color="textLabel">{`${label} ${text}`}</Typography>;
};

export const OptionalBox = styled("div")({
  ["&:empty"]: {
    display: "none",
  },
});

export const CurrentPrice = styled(PriceElements.Price, {
  shouldForwardProp: (prop) => prop !== "soldOut",
})<PriceProps & { soldOut?: boolean }>(({ soldOut, theme }) => ({
  fontWeight: soldOut ? "normal" : "bold",
  color: soldOut ? theme.palette.text.secondary : theme.palette.text.primary,
  textDecoration: soldOut ? "line-through" : "none",
}));

export const OldPrice = styled(PriceElements.Price, {
  shouldForwardProp: (prop) => prop !== "soldOut",
})<PriceProps & { soldOut?: boolean }>(({ soldOut, theme }) => ({
  color: soldOut ? theme.palette.text.primary : theme.palette.text.secondary,
  fontWeight: soldOut ? "bold" : "normal",
  textDecoration: soldOut ? "none" : "line-through",
}));
